import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { BtnComponent } from '../../components/button';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { toast } from 'react-toastify';
import { useGroupChatContext } from '../../context/groupchatContext';
import { RadioInputField } from '../../components/reactHookFormFields/radio';
import { SectionHeader } from '../../components/section';
import { useDisable2FaMutation, useEnableTwoFAMutation, useGenerateBackUpCodesMutation, useGetSecurityInfoQuery, useResendOtpSmsMutation, useVerifyTwoFACodeMutation } from '../../services/chatService';
import { QRCodeSVG } from 'qrcode.react';
import { MaskField } from '../../components/reactHookFormFields/maskField';
import { getBaseUrl } from '../../helpers/utility';
import { FaSpinner } from 'react-icons/fa';
import successImg from '../../assets/images/success-img.png'
import ToggleComponent from '../../components/reactHookFormFields/toggle';
import { Loader } from '../../components/loader';
import ActionDialog from '../../components/actionDialog';
import { NumericField } from '../../components/reactHookFormFields/numericField';
import { ETHIZO_PRACTICE_ID, OAKMED_PRACTICE_ID, SIXTY_TWO_PRACTICE_ID } from '../../utils/practiceIds';


const TwoFa = ({ close2FaPopup, isShowCloseBtn = true }) => {

    const [isCloseBtn, setIsCloseBtn] = useState(isShowCloseBtn);
    const groupChatContext = useGroupChatContext();
    const { authData, isForceOpen2FaPopup, setForceOpen2FaPopup, logoutApp } = useMemo(() => ({
        authData: groupChatContext.authData,
        isForceOpen2FaPopup: groupChatContext.isForceOpen2FaPopup,
        setForceOpen2FaPopup: groupChatContext.setForceOpen2FaPopup,
        logoutApp: groupChatContext.logoutApp

    }));

    const [twoFaAuthentication, setTwoFaAuthentication] = useState({ step: 'fa_option' })
    const [confirmationData, setConfirmationData] = useState({ isOpen: false })
    const { control, handleSubmit, formState: { errors }, setValue, reset } = useForm({
        defaultValues: {
            verification_method: '',
            authentication_status_toggle: ''
        },
    });

    const { data: twoFaStatusInfo, isLoading: isLoadingSecurityInfo, isFetching: isFetchingSecurityInfo } = useGetSecurityInfoQuery(null, { refetchOnMountOrArgChange: true });

    useEffect(() => {
        if (twoFaStatusInfo?.two_factor_auth_enabled) {
            setValue("authentication_status_toggle", twoFaStatusInfo?.two_factor_auth_enabled)
            setTwoFaAuthentication({ step: 'auth_status' })
        }
        else {
            setTwoFaAuthentication({ step: 'fa_option' })
        }
    }, [twoFaStatusInfo])


    const [enableTwoFA, { isLoading }] = useEnableTwoFAMutation();
    const change2FactorOptionsRadioValue = async (value) => {
        const resp = await enableTwoFA({ type: value.key });
        if (resp?.data) {
            setTwoFaAuthentication({ ...resp.data, step: value.key == 'app' ? 'qr_code' : 'validate_code' })
        }
    };

    const handleBackClick = () => {
        setValue("verification_method", "");
        setTwoFaAuthentication({ step: 'fa_option' })
    };

    const moveOnValidateCodeScreen = () => {
        reset();
        setTwoFaAuthentication({ ...twoFaAuthentication, step: 'validate_code' })
    }

    const [verifyTwoFACode, { isLoading: isVerifyingCode }] = useVerifyTwoFACodeMutation();
    const validateTwoFactorCode = async (values) => {
        const resp = await verifyTwoFACode({ id: twoFaAuthentication.id, code: values.verification_code });

        if (resp.data?.length) {
            const auth = JSON.parse(localStorage.getItem("auth"));
            auth.two_factor_auth_enabled = true;
            localStorage.setItem("auth", JSON.stringify(auth));

            setIsCloseBtn(true);
            setTwoFaAuthentication({ ...twoFaAuthentication, backupCodes: resp.data, step: 'back_codes' })
        }
    }

    const [disable2Fa, { isLoading: isDisabling2Fa }] = useDisable2FaMutation();
    const onToggle2FaSecurity = (name, val) => {
        if (val) {
            setTwoFaAuthentication({ step: 'auth_status' })
        }
        else {

            function disbale2FaAPICall() {
                setConfirmationData({ isOpen: false })
                disable2Fa({ nurse_id: authData.nurse_id }).then((res) => {
                    if (res.data.code == 0) {
                        setTwoFaAuthentication({ step: 'fa_option' });
                        toast.success(res.data.msg)
                    }
                })
            }

            function cancelCallBackFun() {
                setValue('authentication_status_toggle', true);
                setConfirmationData({ isOpen: false })
            }

            setConfirmationData({
                isOpen: true,
                title: "Are you sure you want to disable 2FA?",
                callBackFun: disbale2FaAPICall,
                cancelCallBackFun: cancelCallBackFun
            })
        }
    }

    const [resendOtpSms, { isLoading: isSendingOtp }] = useResendOtpSmsMutation();
    const isNurse = !authData?.is_provider;

    const resendSMSCode = async () => {
        try {

            if (!twoFaAuthentication.id) {
                toast.error("Two factor authentication id not found");
                return;
            }
            const auth = JSON.parse(localStorage.getItem("auth"));
            const payload = {
                two_factor_auth_id: authData?.two_factor_auth_id || auth?.two_factor_auth_id || ''
            }

            if (isNurse) {
                payload["user_type"] = "nurse"
            }

            const res = await resendOtpSms(payload)
            const { code, msg } = res?.data || {};

            if (code === 0) {
                toast.success(msg || "Code resent successfully")
            } else if (code !== -1) {
                toast.error(msg || "Failed to resend code")
            }
        } catch (error) {
            toast.error("Failed while resending code")
        }
    }


    const [generateBackUpCodes, { isLoading: isGeneratingCodes }] = useGenerateBackUpCodesMutation();
    const regenerateBackupCodes = () => {

        function regenerateBackupCodeAPICall() {
            generateBackUpCodes({ nurse_id: authData.nurse_id }).then((res) => {
                if (res.data) {
                    setTwoFaAuthentication({ ...twoFaAuthentication, backupCodes: res.data, step: 'back_codes' });
                    setConfirmationData({ isOpen: false })
                }
                else {
                    toast.warning(res.data.msg)
                }
            })
        }

        setConfirmationData({
            isOpen: true,
            title: "You are going to Regenerate Backup Codes, the previous codes will be expired. Are you sure, you want to Regenerate Backup Codes?",
            callBackFun: regenerateBackupCodeAPICall
        })
    }


    const AuthenticatorOptions = () => {
        return (
            <div className="flex flex-col items-center sm:items-center mt-3 min-w-0">

                <div className='flex items-start mb-4 min-w-0 w-full sm:w-auto'>
                    <RadioInputField
                        control={control}
                        title=""
                        spaceX='4'
                        inSameRow={false}
                        labelClass="text-lg text-gray-600 border border-gray-400 rounded-md p-2 mb-2 bg-gray-100"
                        name='verification_method'
                        onChange={(e, name, value) => change2FactorOptionsRadioValue(value)}
                        data={[{ key: 'app', label: 'Google Authenticator' }, { key: 'sms', label: 'SMS' }]}
                    />
                </div>
                <span className="ml-0 sm:ml-5 mt-3 text-center sm:text-left break-words">
                    (
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
                        className="text-blue-600 hover:underline"
                    >
                        Android
                    </a>{" "}/{" "}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                        className="text-blue-600 hover:underline"
                    >
                        iOS
                    </a>
                    )
                </span>
                {isLoading ?
                    <div className="absolute top-10 right-0 left-0 z-20 p-4 flex items-center justify-center">
                        <FaSpinner size="40" className='animate-spin text-black' />
                    </div>
                    : ''
                }
            </div>
        )
    }

    const QRCodeSection = () => {
        return (
            <>
                <div className='text-black mt-3 break-words min-w-0'>Scan the image below with the two-factor authentication app on your mobile phone.</div>
                <div className='flex items-center justify-center mt-3 min-w-0'>
                    <QRCodeSVG
                        value={twoFaAuthentication.qr}
                        title={"Scan in the google authenticator app"}
                        size={200}
                    />
                </div>
                <div className='flex flex-col sm:flex-row items-stretch sm:items-center justify-center mt-3 gap-2'>
                    <BtnComponent text="Back" btnType="default" onClick={handleBackClick} />
                    <BtnComponent text="Validate Code" onClick={moveOnValidateCodeScreen} />
                </div>
            </>
        )
    }

    const BackupCodeSection = () => {
        return (
            <div className='text-black min-w-0'>
                <h1 className='mt-3 font-bold'>Verified</h1>
                <div className='mt-1 break-words'>From now, you'll need to enter an OTP to login</div>
                <div className='flex items-center justify-center'>
                    <img src={successImg} className="rounded-lg" alt="Verification Success" height={100} width={100} />
                </div>
                <div className='mt-3 break-words'>Under "Save your recovery codes", click<strong> Download</strong> to download your recovery codes to your device. Save them to a secure location because your recovery codes can help you get back into your account if you lose access.</div>
                <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 text-center min-w-0">
                    {twoFaAuthentication.backupCodes?.map((backupcode) => (
                        <div key={backupcode.code} className="flex items-center min-w-0 break-all">
                            {backupcode.use_datetime == null ? (
                                <strong>{backupcode.code}</strong>
                            ) : (
                                <strong>
                                    <s>{backupcode.code}</s>
                                </strong>
                            )}
                        </div>
                    ))}
                </div>
                <div className='flex flex-col sm:flex-row items-stretch sm:items-center justify-center mt-3 gap-2'>
                    <BtnComponent text="Download" onClick={downloadBackupCodes} />
                </div>
            </div>
        )
    }

    const CodeValidateSection = () => {

        const maskFieldRef = useRef(null);

        useEffect(() => {
            if (maskFieldRef) {
                maskFieldRef.current?.focus();
            }
        }, []);

        const return2FAText = () => {
            const isNurse = !authData?.is_provider;
            const envUrl = process.env.REACT_APP_API_URL_V1;
            const practiceId = authData?.practice_id || null;

            let env = "";
            if (envUrl) {
                if (envUrl.includes('api-alpha')) {
                    env = "alpha";
                } else if (envUrl.includes('api-bravo')) {
                    env = "bravo";
                } else if (envUrl.includes('api-charlie')) {
                    env = "charlie";
                } else if (envUrl.includes('api-delta')) {
                    env = "delta";
                } else if (envUrl.includes('api-echo')) {
                    env = "echo";
                } else if (envUrl.includes('api-e10x')) {
                    env = "e10x";
                } else if (envUrl.includes('localhost') || envUrl.includes('127.0.0.1')) {
                    env = "local";
                } else if (!envUrl.includes('api-')) {
                    env = "live";
                } else {
                    env = "unknown";
                }
            }

            let msg = "";

            let enableForBravo = practiceId === SIXTY_TWO_PRACTICE_ID && env === "bravo";
            let enableForLive = (practiceId === ETHIZO_PRACTICE_ID || practiceId === OAKMED_PRACTICE_ID) && env === "live";

            if (twoFaAuthentication.type !== "app" && isNurse && (enableForBravo || enableForLive)) {
                msg = "Enter 6-Digit OTP received on you mobile number and email.";
            } else if (twoFaAuthentication.type === "app") {
                msg = "Enter the six-digit code from the Google Authenticator.";
            } else {
                msg = "Enter 6-Digit OTP received on you mobile number.";
            }

            return msg;
        }

        return (
            <>
                <div className='text-black mt-3 break-words min-w-0'>
                    {return2FAText()}
                </div>
                <div className='flex items-center justify-center mt-2 min-w-0'>
                    <div className='w-full sm:w-1/2 min-w-0'>
                        <NumericField
                            ref={maskFieldRef}
                            name="verification_code"
                            title="Enter code"
                            control={control}
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
                            }}
                            rules={{
                                required: {
                                    value: true,
                                    message: "Please enter code",
                                },
                                pattern: {
                                    value: /^\d{6}$/,
                                    message: "Code must be exactly 6 digits",
                                },
                            }}
                            errors={errors}
                        />
                    </div>
                </div>
                <div className='flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center justify-center mt-3 gap-2'>
                    <BtnComponent text="Back" btnType="default" onClick={handleBackClick} />
                    <BtnComponent text="Validate" form="save_2fa_form" loading={isVerifyingCode} type='submit' />
                    {twoFaAuthentication.type == "sms" ?
                        <BtnComponent text="Resend Code" btnType='success' loading={isSendingOtp} onClick={() => change2FactorOptionsRadioValue({ key: 'sms' })} />
                        : null
                    }
                </div>
            </>
        )
    }

    const AuthenticationToggleSection = () => {
        return (
            <div className='text-black text-start min-w-0'>
                {(isDisabling2Fa || isGeneratingCodes) && (
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
                        <Loader />
                    </div>
                )}
                <div className='flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3'>
                    <h1 className='font-bold break-words min-w-0'>
                        {twoFaStatusInfo?.two_factor_auth_enabled ? 'Two factor authentication is enabled' : 'Two factor authentication is not enabled yet'}
                    </h1>
                    <BtnComponent text="Regenerate Backup Codes" onClick={regenerateBackupCodes} />
                </div>
                <div className='mt-1 break-words'>Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in.</div>
                <div className='flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 mt-3 min-w-0'>
                    <h1 className="break-words min-w-0">Two Factor Authentication status</h1>
                    <ToggleComponent
                        name={`authentication_status_toggle`}
                        control={control}
                        label="Enabled"
                        onChange={onToggle2FaSecurity}
                    />
                </div>
            </div>
        )
    }

    const downloadBackupCodes = () => {

        let token = ''
        if (authData?.is_provider) {
            token = '&token=' + authData?.auth
        }
        else {
            token = '&na_auth=' + authData?.auth
        }

        const url = getBaseUrl().api_url + '/two_factor_auth/print_backup_codes.json?new_chat=1&tz=' + new Date().getTimezoneOffset() + token;
        window.open(url, '_blank');
    }

    const stepTitle = {
        fa_option: 'Choose verification method',
        back_codes: 'Save your recovery codes',
        qr_code: 'Authentication Verification',
        validate_code: 'Code Verification'
    }

    if (isLoadingSecurityInfo || isFetchingSecurityInfo) {
        return (
            <div className="absolute top-40 right-0 left-0 z-20 p-4 flex items-center justify-center">
                <FaSpinner size="40" className='animate-spin text-black' />
            </div>
        )
    }


    return (
        <>
            <PageDialogContent
                contentCls="pt-2 px-3 sm:px-4 md:px-5 overflow-y-auto min-w-0"
                hideOverFlow={true}
                contentScroll={false}>
                <form id="save_2fa_form" onSubmit={handleSubmit(validateTwoFactorCode)} className="min-w-0">
                    {twoFaAuthentication.step != 'auth_status' ?
                        <SectionHeader
                            title={stepTitle[twoFaAuthentication.step]}
                        />
                        : null
                    }
                    {twoFaAuthentication.step == 'fa_option' ? <AuthenticatorOptions /> : null}
                    {twoFaAuthentication.step == 'qr_code' ? <QRCodeSection /> : null}
                    {twoFaAuthentication.step == 'validate_code' ? <CodeValidateSection /> : null}
                    {twoFaAuthentication.step == 'back_codes' ? <BackupCodeSection /> : null}
                    {twoFaAuthentication.step == 'auth_status' ? <AuthenticationToggleSection /> : null}

                    <ActionDialog
                        onCancelHandler={() => {
                            if (typeof confirmationData.cancelCallBackFun == 'function') {
                                confirmationData.cancelCallBackFun()
                            }
                            else {
                                setConfirmationData({ isOpen: false })
                            }
                        }
                        }
                        isHideCloseBtn={true}
                        setShowModal={() => setConfirmationData({ isOpen: false })}
                        onConfirmHandler={confirmationData?.callBackFun}
                        showModal={confirmationData?.isOpen}
                        title={confirmationData?.title}
                        confirmButtonText="Yes"
                    />
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                {isCloseBtn ?
                    <BtnComponent text="Close" btnType="default" onClick={close2FaPopup} /> :
                    <>
                        {twoFaAuthentication.step == 'fa_option' && <div className="px-3 sm:px-4 py-5 text-left text-base sm:text-lg text-gray-900 break-words min-w-0">
                            <p>Please enable Two-factor Authentication. The Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in.</p>
                            <p className='mt-1'>Please note, you can’t use the application without enabling the Two-factor authentication.</p>
                        </div>}
                        <BtnComponent text="Logout" btnType="blue" onClick={() => logoutApp()} />
                    </>}
            </PageDialogFooter>
        </>
    );
};

export default TwoFa;
